import { BreakpointExtended } from "@styles/common-styles";

/**
 * Configuration object for responsive column counts.
 * Each breakpoint maps to its column count.
 */
export type ColumnConfig = Record<BreakpointExtended, number>;

/**
 * Represents the current state of breakpoints.
 * Used to determine which column count to use.
 */
export type BreakpointState = {
  /** Whether the viewport matches the "xxxl" breakpoint */
  isScreenXXXL: boolean;

  /** Whether the viewport matches the "xxl" breakpoint */
  isScreenXXL: boolean;

  /** Whether the viewport matches the "xl" breakpoint */
  isXL: boolean;

  /** Whether the viewport matches the "lg" breakpoint */
  isLG: boolean;

  /** Whether the viewport matches the "md" breakpoint */
  isMD: boolean;

  /** Whether the viewport matches the "sm" breakpoint */
  isSM: boolean;
};

/** Estimated height (in pixels) of a single card/item. */
export const ESTIMATE_HEIGHT_CARD = 331;

/** Number of extra rows to render above and below the visible viewport for virtualization. */
export const CARDS_IN_DOM_UP_AND_DOWN = 5;

/** Default column configuration for all breakpoints. */
export const DEFAULT_COLUMN_CONFIG: Required<ColumnConfig> = {
  xxxl: 5,
  xxl: 5,
  xl: 5,
  lg: 4,
  md: 3,
  sm: 1,
  xs: 1,
};

/** Returns the number of columns to use based on the given breakpoint state */
export function getColumnCountFromConfig(
  config: Required<ColumnConfig>,
  bp: BreakpointState
): number {
  if (bp.isScreenXXXL) {
    return config.xxxl;
  }
  if (bp.isScreenXXL) {
    return config.xxl;
  }
  if (bp.isXL) {
    return config.xl;
  }
  if (bp.isLG) {
    return config.lg;
  }
  if (bp.isMD) {
    return config.md;
  }
  if (bp.isSM) {
    return config.sm;
  }
  return config.xs;
}
